export default function addBaseLayoutHandler(url: string): void {
	onload = () => {
		activeSideBarSelectedOption(url);
		changeLoginBackground(url);
	}
}

function activeSideBarSelectedOption(url: string): void {
	const pathsArray: Array<string> =
		[
			'/orders/create',
			'/orders/index',
			'/users',
			'/domainadmin/stores',
			'/domainadmin/services',
			'/domainadmin/items',
			'/domainadmin/economicmissingorders'
		];
	const options: NodeListOf<HTMLDivElement> = document.querySelectorAll('.options-container');

	options.forEach(op => {
		op.classList.remove('options-container--clicked');
		op.firstElementChild.classList.remove('options--clicked');
		op.lastElementChild.classList.remove('text--clicked');
	});

	if (options.length > 0) {
		for (let i = 0; i < pathsArray.length; i++) {

			if (url.includes(pathsArray[i])) {
				options[i].classList.add('options-container--clicked');
				options[i].firstElementChild.classList.add('options--clicked');
				options[i].lastElementChild.classList.add('text--clicked');
				break;
			}
			else if (url === "/" || url === "/orders") {
				options[0].classList.add('options-container--clicked');
				options[0].firstElementChild.classList.add('options--clicked');
				options[0].lastElementChild.classList.add('text--clicked');
				break;
			}
		}
	}
}

function changeLoginBackground(url: string): void {
	const section: HTMLElement = document.querySelector('section.content');

	if (url.includes('/login') || url.includes('resetpassword') || url.includes('register') || url.includes('forgotpassword')) {
		section.classList.add('content--anonymous');
	}
	else {
		section.classList.remove('content--anonymous');
	}
}
